// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/core/place_types/lodging.proto (package carmen, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file proto/model/core/place_types/lodging.proto.
 */
export const file_proto_model_core_place_types_lodging = /*@__PURE__*/
  fileDesc("Cipwcm90by9tb2RlbC9jb3JlL3BsYWNlX3R5cGVzL2xvZGdpbmcucHJvdG8SBmNhcm1lbiqdBQoQTG9kZ2luZ1BsYWNlVHlwZRIiCh5MT0RHSU5HX1BMQUNFX1RZUEVfVU5TUEVDSUZJRUQQABIoCiRMT0RHSU5HX1BMQUNFX1RZUEVfQkVEX0FORF9CUkVBS0ZBU1QQARIqCiZMT0RHSU5HX1BMQUNFX1RZUEVfQlVER0VUX0pBUEFORVNFX0lOThACEiEKHUxPREdJTkdfUExBQ0VfVFlQRV9DQU1QR1JPVU5EEAMSJAogTE9ER0lOR19QTEFDRV9UWVBFX0NBTVBJTkdfQ0FCSU4QBBIeChpMT0RHSU5HX1BMQUNFX1RZUEVfQ09UVEFHRRAFEioKJkxPREdJTkdfUExBQ0VfVFlQRV9FWFRFTkRFRF9TVEFZX0hPVEVMEAYSHwobTE9ER0lOR19QTEFDRV9UWVBFX0ZBUk1TVEFZEAcSIgoeTE9ER0lOR19QTEFDRV9UWVBFX0dVRVNUX0hPVVNFEAgSHQoZTE9ER0lOR19QTEFDRV9UWVBFX0hPU1RFTBAJEhoKFkxPREdJTkdfUExBQ0VfVFlQRV9JTk4QChIjCh9MT0RHSU5HX1BMQUNFX1RZUEVfSkFQQU5FU0VfSU5OEAsSHgoaTE9ER0lOR19QTEFDRV9UWVBFX0xPREdJTkcQDBInCiNMT0RHSU5HX1BMQUNFX1RZUEVfTU9CSUxFX0hPTUVfUEFSSxANEhwKGExPREdJTkdfUExBQ0VfVFlQRV9NT1RFTBAOEikKJUxPREdJTkdfUExBQ0VfVFlQRV9QUklWQVRFX0dVRVNUX1JPT00QDxIjCh9MT0RHSU5HX1BMQUNFX1RZUEVfUkVTT1JUX0hPVEVMEBASHgoaTE9ER0lOR19QTEFDRV9UWVBFX1JWX1BBUksQEUIoWiZnaXRodWIuY29tL3l1bmFjYWJhL2Nhcm1lbi9wcm90by9tb2RlbGIGcHJvdG8z");

/**
 * Describes the enum carmen.LodgingPlaceType.
 */
export const LodgingPlaceTypeSchema = /*@__PURE__*/
  enumDesc(file_proto_model_core_place_types_lodging, 0);

/**
 * Lodging place types
 * TODO: Reconcile with HotelType.
 *
 * @generated from enum carmen.LodgingPlaceType
 */
export const LodgingPlaceType = /*@__PURE__*/
  tsEnum(LodgingPlaceTypeSchema);

